<template>
  <div v-if="selected" class="app-select-tag">
    <div
      v-if="selected"
      v-down-outside="close"
      class="b-input picker-wrap color-item"
      :class="{ open: isOpen }"
      @click="toggle"
    >
      <div class="badge" :style="{ background: selected.color.color }"></div>
      <div class="name">{{ selected.name }}</div>
      <div class="drop-down-wrap">
        <div class="drop-down">
          <div
            v-for="tag in tags"
            :key="tag.id"
            class="color-item select-item"
            @click="select(tag)"
          >
            <div class="badge" :style="{ background: tag.color.color }"></div>
            <div class="name">{{ tag.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { downOutside } from 'app/utils/directives/down-outside';

export default {
  name: 'SelectTag',

  components: {},
  directives: {
    downOutside,
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isOpen: false,
      selected: null,
    };
  },
  computed: {
    ...mapGetters({
      tags: 'tag/tags',
    }),
  },

  mounted() {
    this.selected = this.tags.find(t => t.id == this.value.id);
  },
  methods: {
    select(item) {
      this.$emit('input', item);
    },
    open() {
      this.isOpen = true;
    },
    close() {
      this.isOpen = false;
    },
    toggle() {
      if (this.isOpen) {
        this.isOpen = false;
      } else {
        this.isOpen = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'styles/mixins.scss';

.app-select-tag {
  .color-item {
    display: flex;
    align-items: center;
    padding: 10px 12px;
    cursor: pointer;

    .badge {
      width: 12px;
      height: 12px;
      border-radius: 50%;
    }
    .name {
      margin-left: 10px;
    }
  }

  .select-item {
    &:hover {
      background: #f6f6f6;
    }
  }

  .picker-wrap {
    position: relative;
    border-radius: 6px;
    padding-top: 9px;
    padding-bottom: 9px;
    .drop-down-wrap {
      display: flex;
      position: absolute;
      z-index: 10;
      overflow: hidden;
      border-left: 1px solid #d7e2fe;
      border-right: 1px solid #d7e2fe;
      border-bottom: 1px solid #d7e2fe;

      border-radius: 0 0 6px 6px;
      top: 31px;
      left: -1px;
      width: 100%;
      max-height: 0;
      background: white;
      transition: max-height 0.2s ease-out;
      padding-bottom: 4px;
    }
    .drop-down {
      width: 100%;
      overflow: auto;
      margin-top: 7px;

      @include scrollbar(4px);
    }

    &.open {
      .picker-wrap {
        border-radius: 6px 6px 0 0;
      }
      .drop-down-wrap {
        max-height: 21vh;
        z-index: 20;
      }
    }
  }
}
</style>
